type InitParams = {
  conversationId: string | undefined
  userToken: string | undefined
}

export function resolveInitParams(
  propsConversationId: string | undefined,
  propsUserToken: string | undefined,
  storageConversationId: string | undefined,
  storageUserToken: string | undefined
): InitParams {
  let initParams: InitParams

  if (propsUserToken && propsConversationId) {
    initParams = {
      conversationId: propsConversationId,
      userToken: propsUserToken,
    }
  } else if (propsUserToken) {
    initParams = {
      conversationId: undefined,
      userToken: propsUserToken,
    }
  } else {
    initParams = {
      conversationId: storageConversationId,
      userToken: storageUserToken,
    }
  }

  return initParams
}
